import { UPPER_CASE_REGEX, NUMBER_REGEX, SYMBOL_REGEX } from '../regex';
import { maxLength, required } from 'vuelidate/lib/validators';

/**
 * Min length: 6
 * Requires:
 *  - At least one symbol
 *  - At least one upper case character
 *  - At least one number
 *
 * @param password The password to validate
 * @returns {boolean} True if the password is valid
 */
export function isValidSignUpPassword(password) {
  if (!password || typeof password !== 'string' || password.length < 8) {
    return false;
  }

  const upperCaseMatch = password.match(UPPER_CASE_REGEX) || [];
  const numberMatch = password.match(NUMBER_REGEX) || [];
  const symbolMatch = password.match(SYMBOL_REGEX) || [];

  return Boolean(
    upperCaseMatch.length && numberMatch.length && symbolMatch.length
  );
}

export const vuelidatePasswordValidations = {
  required,
  valid: isValidSignUpPassword,
  maxLength: maxLength(100)
};
